import 'jquery-jcrop';
import app from 'app';

export default Backbone.View.extend({
  id: 'thumbnailPickerView',
  className: '',
  defaultOptions: {
    usemodal: true, // open as bootstrap modal
  },
  /**
   * destroy plugins and any non-default additional data
   */
  onClose: function () {
    if (this.$el.modal) {
      this.$el.modal('hide');
    }
  },

  initialize: function (options) {
    this.task = options.task;
    this.closeModal = options.closeModal;
    this.template = app.compileTemplate.$('#thumbnailPickerView-tmpl');
    this.templateAsset = app.compileTemplate.$(
      '#thumbnailPickerView-asset-tmpl'
    );
    // leftover: think - how to update poster if asset updates its thumbnail
    this.options = $.extend({}, this.defaultOptions, options);
  },

  render: function () {
    const potentialThumbnails = this.task.getPotentialThumbnails();
    const context = {
      _videoPosterUrl:
        app.namespace.Controller.AssetController.getVideoPosterUrl(this.model),
      _potentialThumbnails: potentialThumbnails,
      _bShowErrorMessage: this.options.displayState,
      _isStoryboard: !!this.task.get('template'),
    };

    this.$el.append(this.template(context));
    if (this.options.usemodal) {
      this.$el.addClass('modal');
      this.$el.modal({ backdrop: 'static', keyboard: false, show: false });
    }

    if (!_.isEmpty(potentialThumbnails)) {
      const tmpEl = document.createDocumentFragment();
      _.each(
        potentialThumbnails,
        function (asset) {
          tmpEl.appendChild(this._renderAssetEl(asset));
        }.bind(this)
      );
      this.$('.list').append(tmpEl);
    }

    return this;
  },

  _renderAssetEl: function (asset) {
    const context = {
      _id: asset.id,
      _type: asset.type,
      _selected: asset.id === this.model.get('id'),
      _image: app.namespace.Controller.AssetController.getVideoPosterUrl(asset),
      _portrait: asset.portrait,
    };
    return $(this.templateAsset(context))[0];
  },

  show: function () {
    this.closingPromise = $.Deferred();
    this.$el.show();
    if (this.options.usemodal) {
      this.$el.modal('show');
    }

    this.markSelectedAsset();

    return this.closingPromise;
  },
  markSelectedAsset: function () {
    if (this.model.get('id')) {
      // init crop selection if thumbnail is chosen
      this._initCrop();
      // if relevant model is rendered in the list - make it visible
      const $selected = this.$('.list .selected');
      if ($selected.length) {
        $selected[0].scrollIntoView();
      }
    } else if (this.$('.list .asset').length) {
      // thumbnail not chosen - select first one
      // crop selection will be initialized as a result of asset click
      // todo: shahar this is an ugly hack we need to change it
      this.$('.list .asset').first().trigger('click');
      // setTimeout(function(){
      //    this.$('.list .asset').first().trigger('click');
      // }.bind(this),200);
      //      this.$('.list .asset').first().trigger('click');
    } else {
      // nothing to choose from - disable apply action
      this.$('[data-action="apply"]').attr('disabled', true);
    }
  },
  events: {
    'click [data-action]': '_action_Click',
    'click .asset': '_asset_Click',
    'click .js-close-modal': '_closeModal',
  },

  _action_Click: _.debounce(
    function (e) {
      const action = $(e.currentTarget).data('action');
      if (/apply/i.test(action)) {
        this.apply();
        this.closingPromise.resolve();
      } else {
        this.model = null; // reset current model meaning that poster is not selected
        this.closingPromise.reject();
      }
    },
    app.TIME.MENTAL.λ,
    { leading: true, trailing: false }
  ),

  _asset_Click: _.debounce(
    function (e) {
      const $this = $(e.currentTarget);

      const asset = app.rootStore.getters.selectedAssets.find(
        (a) => a.id === $this.data('id')
      );
      this.model = new app.namespace.Model.AssetModel(asset, {
        parse: false,
      });
      $this.addClass('selected').siblings('.selected').removeClass('selected');

      this._resetCropArea();
    },
    app.TIME.MENTAL.λ,
    { leading: true, trailing: false }
  ),

  _resetCropArea: function () {
    const $img = this.$('#poster-crop');

    if (this.jcropApi) {
      this.jcropApi.destroy();
      this.jcropApi = null;
    }

    $img.attr({
      src: app.namespace.Controller.AssetController.getVideoPosterUrl(
        this.model
      ),
      style: '',
    });

    this._initCrop();
  },

  _updateThumbnail: function (model) {
    const $model = this.$('.asset[data-id="' + model.get('id') + '"]');
    if ($model.length) {
      // update thumbnail in the list
      $model.replaceWith(this._renderAssetEl(model));
      if ($model.is('.selected')) {
        // update #poster-crop
        this._resetCropArea();
      }
    }
  },

  _initCrop: function () {
    if (!this.isVisible()) {
      return;
    }
    const img = this.$('#poster-crop')[0];
    if (!img.complete) {
      // async recursion aka "call me again when you loaded"
      $(img).one('load', this._initCrop.bind(this));
      return;
    }

    this.imgWidth = img.naturalWidth;
    this.imgHeight = img.naturalHeight;

    // init cropper plugin, let it know to keep relation to the true size of the image
    const jcropOptions = {
      trueSize: [this.imgWidth, this.imgHeight],
      aspectRatio: this.task.get('_aspectRatio').ratio,
      allowSelect: true,
      minSize: [50, 50 * this.task.get('_aspectRatio').ratio],
      onRelease: () => {
        const defaultSelection = this._getDefaultSelection(
          this.imgWidth,
          this.imgHeight
        );
        this.jcropApi.setSelect([
          defaultSelection.cropX,
          defaultSelection.cropY,
          defaultSelection.cropX1,
          defaultSelection.cropY1,
        ]);
      },
    };
    if (this.jcropApi) {
      this.jcropApi.setOptions(jcropOptions);
    } else {
      this.jcropApi = $.Jcrop(img, jcropOptions);
    }

    if (this.model.hasSELECTION()) {
      this.jcropApi.setSelect([
        this.model.getAGD('cropX') * this.imgWidth,
        this.model.getAGD('cropY') * this.imgHeight,
        this.model.getAGD('cropX1') * this.imgWidth,
        this.model.getAGD('cropY1') * this.imgHeight,
      ]);

      // ensure selection is visible
      const scrollToY = this.jcropApi.tellScaled().y - 20;
      if (scrollToY > 0) {
        this.$('.image-asset-container').scrollTop(scrollToY);
      }
    } else {
      const defaultSelection = this._getDefaultSelection(
        this.imgWidth,
        this.imgHeight
      );
      this.jcropApi.setSelect([
        defaultSelection.cropX,
        defaultSelection.cropY,
        defaultSelection.cropX1,
        defaultSelection.cropY1,
      ]);
    }

    this.jcropApi.enable();
  },

  _getDefaultSelection: function (width, height) {
    const rv = {};
    const selectionOffset = 0.9;
    const selectionHeight = window.parseInt(height * selectionOffset);
    const selectionWidth =
      selectionHeight * this.task.get('_aspectRatio').ratio;

    rv.cropX = (width - selectionWidth) / 2;
    rv.cropY = (height - selectionHeight) / 2;
    rv.cropX1 = selectionWidth + rv.cropX;
    rv.cropY1 = selectionHeight + rv.cropY;

    return rv;
  },

  apply: function () {
    app.analytics('thumbnailPicker:select');

    if (this.jcropApi && this.imgWidth && this.imgHeight) {
      const selection = this.jcropApi.tellSelect();
      this.model = new this.model.constructor(this.model.attributes);
      this.model.setAGD({
        effectType: app.imageEffectType.CROP,
        cropX: selection.x / this.imgWidth,
        cropY: selection.y / this.imgHeight,
        cropX1: selection.x2 / this.imgWidth,
        cropY1: selection.y2 / this.imgHeight,
      });
    }
  },

  _closeModal: function () {
    // remove the image container before close modal because
    // it takes an additional second for the asset to disappear
    this.$('.image-asset-container').remove();
    _.isFunction(this.closeModal) && this.closeModal();
  },
});
